/**
 * Human-readable coupon type for Campaign Management UI.
 * API may return `nth_order` for first-order coupons — show as "First Order".
 */
export function formatCouponTypeLabel(type?: string | null): string {
  if (type === undefined || type === null || type === "") return "-";
  const raw = String(type).trim();
  const lower = raw.toLowerCase();
  if (lower === "nth_order") return "First Order";
  if (lower === "percent") return "Percent";
  if (lower === "flat") return "Flat";
  if (lower === "preorder") return "Preorder";
  return raw
    .split(/[\s_-]+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
